/* src/app/core/widgets/toast/toast.component.scss */
.toastStack {
  position: fixed;
  top: 4.5rem;
  right: 1rem;
  z-index: 1200;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-width: 22rem;
  pointer-events: none;
}
.toastCard {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  background: #fff;
  color: #000;
  border-top: 3px solid #f99420;
  border-radius: 0.5rem;
  padding: 0.75rem 0.9rem;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.15);
  pointer-events: auto;
  animation: toastIn 0.18s ease-out;
}
.toastMessage {
  flex: 1 1 auto;
  font-size: 0.85rem;
  line-height: 1.35;
  word-break: break-word;
  color: #000;
}
.toastClose {
  flex: 0 0 auto;
  background: transparent;
  border: 0;
  color: rgba(0, 0, 0, 0.45);
  font-size: 1.1rem;
  line-height: 1;
  cursor: pointer;
  padding: 0;
}
.toastClose:hover {
  color: #000;
}
@keyframes toastIn {
  from {
    opacity: 0;
    transform: translateX(1rem);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
/*# sourceMappingURL=toast.component.css.map */
